import { Component } from '@angular/core';
import { FormsModule, Validators, NgForm } from '@angular/forms';
import { UserService } from '../_Services/user.service';
import { Router } from '@angular/router'; 
import { CommonService } from '../_Services/common.service';

@Component({
  templateUrl: 'add.component.html'
})
export class AddComponent {

	model: any = {group_id: ''};
    groups = [];
    responseStatus:Object= [];
    status:boolean ;
    error = ''; 
	constructor(private router: Router, private userService: UserService, private commonService: CommonService) { }

	onSubmit() { 
		this.userService.addUser(this.model).subscribe(result => {
            console.log(result);
            if (result.status === true) {
                this.error = '';
                this.router.navigate(['/users/users']);
            } else {
                this.error = result.message; 
            }
        }); 
	}

    changeShape(group_id){ 
        this.model.group_id = group_id;
    }

    ngOnInit() {  
        this.commonService.getGroups().subscribe(result => { 
            this.groups = result;
        });  
    }

}



// WEBPACK FOOTER //
// ./src/app/users/add.component.ts